<header *ngIf="headerShow"></header>
<router-outlet></router-outlet>
<footer *ngIf="footerShow" ></footer>